// @ts-strict-ignore
import { Component } from "@angular/core";
import * as C from "../../../../../../shared/constants/globals.constants";
import { EWizDynamicBaseClassComponent } from "src/app/modules/esim/shared/classes/ewiz-dynamic.class";

@Component({
  selector: C.EWIZ_CONFIG_SUCI_CALCULATION,
  templateUrl: "./config-suci-calculation.component.html",
  standalone: false
})
export class EWizConfigSuciCalculationComponent extends EWizDynamicBaseClassComponent {
  updateSUCI() {
    if (this.profileValues.suciEncryptionScheme.suciCalculation && +this.profileValues.suciEncryptionScheme.suciCalculation === 1) {
      this.profileValues.usimServiceTable.usimService124 = true;
      this.profileValues.usimServiceTable.usimService125 = false;
    } else if (this.profileValues.suciEncryptionScheme.suciCalculation && +this.profileValues.suciEncryptionScheme.suciCalculation === 2) {
      this.profileValues.usimServiceTable.usimService124 = true;
      this.profileValues.usimServiceTable.usimService125 = true;
    } else {
      this.profileValues.usimServiceTable.usimService124 = false;
      this.profileValues.usimServiceTable.usimService125 = false;
    }

    this.handleFormEvents();
  }
}
